export default class Aisle{
    id:string;
    roomCode:string;
    warehouseCode :string;
    indexNo:number;
    length:number;
    height:number;
    width:number;
    creatorUserName:string;
    creationTime:Date;
    countBins:number;
}